export type FlightSortType =
  | 'price'
  | 'duration'
  | 'score'
  | `leg1_departure_time`
  | `leg2_departure_time`
  | `leg3_departure_time`
  | `leg4_departure_time`
  | `leg5_departure_time`
  | `leg6_departure_time`;

export enum FlightSelectedSortTypeForGenzoTracking {
  PRICE = 'cheapest',
  DURATION = 'fastest',
  SCORE = 'best_experience',
  FLIGHT_TIME = 'by_flight_time',
}
